import api from './api';

export const trichDanService = {
    getRandomQuote: () => {
        return api.get('/trichdan/random');
    }
};
